module.exports = __webpack_public_path__ + "static/man-s-7cdfcc9238da8ecba603076fa9f0b152.jpg";